import { styleFilterOptions } from "../state/constants";

export const getCollectionParams = (collection: { conditionTags?: { value?: string } | null }) => {
  const conditionTags = collection.conditionTags?.value;

  if (conditionTags) {
    const tagsArray = JSON.parse(conditionTags);
    const styleTag = styleFilterOptions.some((option) => tagsArray.includes(option.value));
    return styleTag ? `style=${tagsArray.join(",")}` : `subject=${tagsArray.join(",")}`;
  }
  return "";
};
